<app-layouts>
    <div class="main-setting" content>
        <div class="content">
            <router-outlet></router-outlet>
        </div>
    </div>
</app-layouts>